export default __webpack_public_path__ + "static/media/sounds/clpl_practice_incorrect_answer_selected.mp3";